import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse ,HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';


@Injectable()
export class NovosKitsProvider {

  apiRoot: string = 'http://192.99.185.73:8070';

  constructor(public http: HttpClient) {
    console.log('Hello NovosKitsProvider Provider');
  }

  getListarKits(CodigoVendedor: string, CategoryMLB: string, Limite: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    return this.http
      .get(this.apiRoot + '/Vendedor/ListarKits?codigosVendedor=' + CodigoVendedor + '&categoriaMLB=' + CategoryMLB + '&limit=' + Limite, { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  revisarKits(Codigo: string){

    const header = new HttpHeaders({ 'Content-Type':  'application/json', 'Authorization': 'bearer ' + localStorage.getItem('userToken') })

    let Email = localStorage.getItem('userLogin');

    return this.http
      .post(this.apiRoot + '/Anuncios/RevisarKit?Mlb=' + Codigo + '&email=' + JSON.parse(Email).user_mail, Array.from(Codigo), { headers: header })
      .do(data => JSON.stringify(data))
      .catch(this.handleError);
  }

  private handleError(error: HttpErrorResponse){

    let errorMessage = {};
    if (error.error instanceof Error) {

        // A client-side or network error occurred. Handle it accordingly.

        errorMessage = `An error occurred: ${error.error.message}`;
        console.log(error.error);

    } else {

        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        errorMessage = { status: error.status, message: error.error.Message };
        console.log(error.error);

        if(error.status == 401){

        }

    }

    return Observable.throw(errorMessage);
  }

}



// WEBPACK FOOTER //
// ./src/providers/novos-kits/novos-kits.ts